import { useState } from "react";
import { Trophy, CheckCircle2 } from "lucide-react";
import { FancallInfoDialog } from "@/components/FancallInfoDialog";

export const FancallInfoBanner = ({ raffles = [], joinerId, onDone }) => {
  const [open, setOpen] = useState(null);
  const wins = raffles.filter((r) => r.won);
  if (!wins.length) return null;
  return (
    <div data-testid="fancall-info-banner" className="mt-6 rounded-2xl border border-amber-400/40 bg-amber-400/[0.07] p-4 sm:p-5 space-y-3">
      {wins.map((r) => (
        <div key={r.raffle_id} className="flex flex-wrap items-center gap-3">
          <span className="inline-flex min-w-0 items-center gap-2 text-sm text-amber-100">
            <Trophy className="h-4 w-4 shrink-0 text-amber-300" />
            <span className="min-w-0 break-words"><span className="font-bold">Fancall winner</span> · {r.name}</span>
          </span>
          {r.info_locked ? (
            <span data-testid={`fancall-info-sent-${r.raffle_id}`} className="ml-auto inline-flex items-center gap-1.5 text-xs font-semibold text-emerald-300">
              <CheckCircle2 className="h-4 w-4" /> Fancall Information sent
            </span>
          ) : (
            <button type="button" data-testid={`fancall-info-btn-${r.raffle_id}`} onClick={() => setOpen(r)}
              className="ml-auto rounded-full bg-amber-400 px-4 py-1.5 text-sm font-bold text-zinc-950 transition-colors hover:bg-amber-300">
              Fancall Information
            </button>
          )}
        </div>
      ))}
      <FancallInfoDialog raffle={open} joinerId={joinerId} onClose={() => setOpen(null)} onDone={() => { setOpen(null); onDone(); }} />
    </div>
  );
};
